import ACTIONS, { FETCH_STATUS } from '../app.constants';
import { CommentList, Form, Inspection, ViolationList, Comment, Violation } from '../modules/application/types';
import { LimitAndSkipData } from '../modules/calendar/types';

export const getInspectionDetail = {
    pending: {
        type: ACTIONS.GET_INSPECTION_DETAIL_BY_ID.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (inspection: Inspection, editForm: Form | undefined) => ({
        type: ACTIONS.GET_INSPECTION_DETAIL_BY_ID.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: {
            inspection,
            editForm,
        },
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_INSPECTION_DETAIL_BY_ID.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const updateInspection = {
    pending: {
        type: ACTIONS.UPDATE_INSPECTION.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: Inspection) => ({
        type: ACTIONS.UPDATE_INSPECTION.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.UPDATE_INSPECTION.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const addInspectionComment = {
    pending: {
        type: ACTIONS.ADD_INSPECTION_COMMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: Comment) => ({
        type: ACTIONS.ADD_INSPECTION_COMMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_INSPECTION_COMMENT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getInspectionCommentList = {
    pending: {
        type: ACTIONS.INSPECTION_COMMENT_LIST.PENDING,
    },
    success: (data: CommentList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.INSPECTION_COMMENT_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.INSPECTION_COMMENT_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getViolationListAssociatedWithInspection = {
    pending: {
        type: ACTIONS.GET_INSPECTION_VIOLATION_LIST.PENDING,
    },
    success: (data: ViolationList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.GET_INSPECTION_VIOLATION_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_INSPECTION_VIOLATION_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const addViolationAssociatedWithInspection = {
    pending: {
        type: ACTIONS.ADD_INSPECTION_VIOLATION.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: Violation[]) => ({
        type: ACTIONS.ADD_INSPECTION_VIOLATION.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_INSPECTION_VIOLATION.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const deleteViolationAssociatedWithInspection = {
    pending: {
        type: ACTIONS.DELETE_INSPECTION_VIOLATION.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (violationId: string) => ({
        type: ACTIONS.DELETE_INSPECTION_VIOLATION.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: { violationId },
    }),
    error: (error: Error) => ({
        type: ACTIONS.DELETE_INSPECTION_VIOLATION.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getInspectionDetailsBegin = (id: string) => {
    return {
        type: ACTIONS.GET_INSPECTION_DETAIL_BY_ID_BEGIN,
        payload: { id },
    };
};

export const updateInspectionBegin = (data: Inspection, inspectionId: string) => {
    return {
        type: ACTIONS.UPDATE_INSPECTION_BEGIN,
        payload: { data, inspectionId },
    };
};

export const addInspectionCommentBegin = (data: string, inspectionId: string) => {
    return {
        type: ACTIONS.ADD_INSPECTION_COMMENT_BEGIN,
        payload: { data, inspectionId },
    };
};

export const getInspectionCommentListBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.INSPECTION_COMMENT_LIST_BEGIN,
        payload: { id },
        paginationData,
    };
};

export const getViolationListAssociatedWithInspectionBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_INSPECTION_VIOLATION_LIST_BEGIN,
        payload: { id },
        paginationData,
    };
};

export const deleteViolationAssociatedWithInspectionBegin = (violationId: string) => {
    return {
        type: ACTIONS.DELETE_INSPECTION_VIOLATION_BEGIN,
        payload: { violationId },
    };
};

export const addViolationAssociatedWithInspectionBegin = (data: Violation) => {
    return {
        type: ACTIONS.ADD_INSPECTION_VIOLATION_BEGIN,
        payload: { data },
    };
};

export const getAddInspectionFormById = {
    pending: {
        type: ACTIONS.GET_ADD_INSPECTION_FORM_BY_ID.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (editForm: Form) => ({
        type: ACTIONS.GET_ADD_INSPECTION_FORM_BY_ID.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: editForm,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_ADD_INSPECTION_FORM_BY_ID.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getAddInspectionFormByIdBegin = (formId: string) => {
    return {
        type: ACTIONS.GET_ADD_INSPECTION_FORM_BY_ID_BEGIN,
        payload: { id: formId },
    };
};
